// extracted by css-extract-rspack-plugin
export default {"titleBar":"AaXquku_qdMLenNU__titleBar___","title":"cTVuiYM7RcO91xvG__title___","popoverContent":"LBoRdnuXmYHCUyKc__popoverContent___","popover":"quHkjYyFdoeh4yEO__popover___"};